
// SVG Icon: plus
export default { id: "terriajs-plus" };
export const id = "terriajs-plus";
export const name = "plus";
